import React from 'react';
import LeadCapture from '../leadCapture/LeadCapture';
import ContactUsSchema from './components/contact-us schema/ContactUsSchema';

const ContactUs: React.FC = () => {
  return (
    <div>
      <ContactUsSchema />
      <LeadCapture source="contact-us" />
    </div>
  );
};

export default ContactUs;
